import React from 'react'
import styled from 'styled-components'
import breakpoints from 'theme/breakpoints'

const SLIDES = 3;
const DOTS = 8;

/**
 * Esqueleto do carrossel de destaques.
 *
 * Antes era um único retângulo cinza ocupando toda a faixa, que não tinha
 * relação com o conteúdo que ia chegar: o carrossel renderiza três cards
 * (um no mobile), cada um com a arte e uma faixa inferior de título e data.
 * Um placeholder que não imita o resultado provoca um salto de layout na
 * troca e não ajuda o usuário a antecipar o que está carregando.
 */
export default function CarouselSkeleton() {
    return (
        <Wrapper aria-hidden='true'>
            <SlidesRow>
                {Array.from({ length: SLIDES }).map((_, index) => (
                    <Slide key={index} $index={index}>
                        <Art>
                            <TagPlaceholder />
                            <Caption>
                                <TitleBar />
                                <DateBar />
                            </Caption>
                        </Art>
                    </Slide>
                ))}
            </SlidesRow>

            <Dots>
                {Array.from({ length: DOTS }).map((_, index) => (
                    <Dot key={index} />
                ))}
            </Dots>
        </Wrapper>
    );
}

const shimmer = `
    background: linear-gradient(90deg, #f0f0f0 25%, #e4e4e4 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: carouselWave 1.6s infinite linear;

    @keyframes carouselWave {
        0% { background-position: -200px 0; }
        100% { background-position: calc(200px + 100%) 0; }
    }

    @media (prefers-reduced-motion: reduce) {
        animation: none;
    }
`;

const Wrapper = styled.div`
    width: 100%;
`;

const SlidesRow = styled.div`
    display: flex;
    gap: 12px;
    width: 100%;
`;

const Slide = styled.div`
    flex: 1;
    min-width: 0;

    /* Espelha o breakpoint do Swiper: 1 slide abaixo de 1200px, 3 acima.
       Os slides extras existem no DOM mas ficam ocultos, para o esqueleto
       ocupar exatamente a mesma área do carrossel montado. */
    ${({ $index }) => $index > 0 && `
        display: none;
    `}

    @media screen and (min-width: ${breakpoints.lg}) {
        display: block;
    }
`;

const Art = styled.div`
    position: relative;
    width: 100%;
    aspect-ratio: 16 / 9;
    border-radius: 12px;
    overflow: hidden;
    ${shimmer}
`;

const TagPlaceholder = styled.div`
    position: absolute;
    top: 10px;
    left: 8px;
    width: 46px;
    height: 18px;
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.55);
`;

const Caption = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 10px 12px;
    border-radius: 0 0 12px 12px;
    background: rgba(214, 214, 214, 0.75);
`;

const TitleBar = styled.div`
    width: 70%;
    height: 11px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.75);
`;

const DateBar = styled.div`
    width: 40%;
    height: 9px;
    margin-top: 7px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.55);
`;

const Dots = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    margin-top: 14px;
`;

const Dot = styled.span`
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #e4e4e4;
`;
